<blaze-dialog [showCloseButton]="false" [showFooter]="false" contentClass="pt-16">
  <div icon class="title-icon">
    <mat-icon svgIcon="icon_blaze_24" />
  </div>

  <div title>Assign Parameter</div>

  <div actions>
    <button blazeIconButton (click)="closeDialog()">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  </div>

  <div content>
    <form (ngSubmit)="save()" [formGroup]="formCtrl">
      @if (formValue.type !== ParameterType.Pagination) {
        <div class="form-control parameter mb-16">
          <label class="field-label bd-field-label">Parameter Name</label>
          <input class="bd-text-input tall" formControlName="name" />
        </div>
      }

      <div class="form-group">
        <div class="form-control">
          <mat-button-toggle-group class="button-group-input" name="type" formControlName="type">
            <mat-button-toggle [value]="ParameterType.Dynamic">Dynamic</mat-button-toggle>
            <mat-button-toggle [value]="ParameterType.Pagination">Pagination</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        @if (formValue.type === ParameterType.Dynamic) {
          <div class="form-control ml-8">
            <mat-slide-toggle disableRipple class="bd-toggle px-8" formControlName="optional">
              Optional
            </mat-slide-toggle>
          </div>
        }
        @if (formValue.type === ParameterType.Pagination) {
          <div class="form-control ml-8 grow">
            <blaze-select
              [allowNone]="false"
              [options]="paginationMethods"
              [showNoneOption]="false"
              [showSelection]="true"
              class="select-input tall"
              formControlName="paginationMethod"
            />
          </div>
        }
      </div>

      @if (formValue.type !== ParameterType.Pagination) {
        <div class="form-group">
          <div class="form-control grow">
            <label class="field-label bd-field-label">Data type</label>
            <blaze-select
              [allowNone]="false"
              [options]="dataTypes"
              [showNoneOption]="false"
              [showSelection]="true"
              class="select-input tall"
              formControlName="dataType"
            />
          </div>
        </div>
      }

      @if (showDefaultValueField) {
        <div class="form-group">
          <div class="form-control grow">
            <label class="field-label bd-field-label">Default value</label>
            <blaze-typed-value-input-field
              [dataType]="formValue.dataType"
              [fieldCtrl]="formCtrl.controls.defaultValue"
              fieldName="type"
            />
          </div>
        </div>
      }

      <button class="w-full" type="submit" blazeButton [disabled]="formCtrl.invalid">
        ASSIGN
      </button>
    </form>
  </div>
</blaze-dialog>
